export default __webpack_public_path__ + "static/media/yellow-wave.206fa7c6.svg";